import { UNEMPLOYED_SITUATIONS } from '~app/components/LaborInformation/LaborForm/LaborFields/constants';
import { isEmployed } from '~utils/employmentSituation';
import { getScrapersTargets } from '~utils/scrapers';

export const hasWork = employmentSituation => !UNEMPLOYED_SITUATIONS.includes(employmentSituation);

export const hasExpectedIncomes = (employmentSituation, incomes) =>
  isEmployed(employmentSituation) ? incomes > 0 : incomes === '0';

export const getIncomesValues = (simulation, prefix) => {
  const targets = getScrapersTargets(prefix);
  return {
    changeIncumbentLoading: simulation.changeIncumbentLoading,
    afpReceived: simulation[targets.afpReceived],
    siiReceived: simulation[targets.siiReceived],
    afpWarning: simulation[targets.afpWarning],
    siiWarning: simulation[targets.siiWarning]
  };
};
